import { PaymentMethod } from '@prisma/client';
import { createContext } from 'react';
import {
  SplitPaymentForm,
  SplitPaymentsGroupWithCustomer,
} from '../../types/payments';
import { getSplitPaymentsForm } from '../../helpers/payments';

export type SplitPaymentMethod = {
  amount: number;
  /** Fee-bearing base (service + retail) covered by this payment, in cents. */
  baseCoveredCents: number;
  paymentId: string;
  isPaymentCollected: boolean;
  paymentMethod: PaymentMethod;
  paymentIntentId: string | undefined;
  paymentIntentClientSecret: string | undefined;
  isError?: boolean;
};

export type SplitPaymentsState = {
  form: SplitPaymentForm;
  currentIndex: number;
  splitPaymentsGroup: SplitPaymentsGroupWithCustomer | null;
  paymentMethods: SplitPaymentMethod[];
};

export const DEFAULT_SPLIT_PAYMENTS_STATE: SplitPaymentsState = {
  currentIndex: 0,
  splitPaymentsGroup: null,
  paymentMethods: [],
  form: getSplitPaymentsForm(0, [], 0),
};

export type SplitPaymentsStateAction =
  | {
      type: 'ADD_PAYMENT_METHOD';
      payload: SplitPaymentMethod;
    }
  | {
      type: 'UPDATE_PAYMENT_METHOD';
      payload: {
        index: number;
        paymentMethod: Partial<SplitPaymentMethod>;
      };
    }
  | {
      type: 'RESET';
    }
  | {
      type: 'SET_SPLIT_PAYMENTS_GROUP';
      payload: SplitPaymentsState['splitPaymentsGroup'];
    }
  | {
      type: 'SET_CURRENT_INDEX';
      payload: SplitPaymentsState['currentIndex'];
    }
  | {
      type: 'SET_PAYMENT_COLLECTED';
      payload: {
        index: number;
        isPaymentCollected: boolean;
      };
    }
  | {
      type: 'SET_FORM';
      payload: SplitPaymentsState['form'];
    };

interface SplitPaymentsContextType {
  state: SplitPaymentsState;
  dispatch: React.Dispatch<SplitPaymentsStateAction>; // Replace 'any' with the actual action type if you have one
}

const defaultContextValue: SplitPaymentsContextType = {
  state: DEFAULT_SPLIT_PAYMENTS_STATE,
  dispatch: () => {},
};

export const SplitPaymentsContext =
  createContext<SplitPaymentsContextType>(defaultContextValue);
